import { NonNilProperty } from "../types";
import { isDefined } from "./is-defined";

export function arePropertiesDefined<T, K extends keyof T>(
    value: T | null | undefined,
    ...fields: K[]
): value is NonNilProperty<T, K> {
    if (value === null || value === undefined) {
        return false;
    }

    return fields.every((field) => isDefined(value[field]));
}
